import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../components/context/LanguageContext';
import './Home.css';

import image1 from '../images/hero1.webp';
import image2 from '../images/hero2.webp';
import image3 from '../images/hero3.webp';
import image4 from '../images/hero4.webp';
import image5 from '../images/hero5.webp';
import image6 from '../images/hero6.webp';
import image7 from '../images/hero7.webp';
import image8 from '../images/hero8.webp';
import image9 from '../images/hero9.webp';
import image10 from '../images/hero10.webp';

const backgroundImages = [
  image1, image2, image3, image4, image5,
  image6, image7, image8, image9, image10
];

const Home = () => {
  const { t } = useLanguage();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [animationType, setAnimationType] = useState("fade");
  const [isCooldown, setIsCooldown] = useState(false);

  const autoSlideRef = useRef(null);

  const triggerCooldown = () => {
    setIsCooldown(true);
    setTimeout(() => setIsCooldown(false), 1500);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === backgroundImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? backgroundImages.length - 1 : prev - 1
    );
  };

  const startAutoSlide = () => {
    if (autoSlideRef.current) clearInterval(autoSlideRef.current);
    autoSlideRef.current = setInterval(() => nextImage(), 7000);
  };

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(autoSlideRef.current);
  }, []);

  const handleNextClick = () => {
    if (isCooldown) return;
    nextImage();
    triggerCooldown();
    startAutoSlide();
  };

  const handlePrevClick = () => {
    if (isCooldown) return;
    prevImage();
    triggerCooldown();
    startAutoSlide();
  };

  const goToImage = (index) => {
    if (isCooldown) return;
    setCurrentImageIndex(index);
    triggerCooldown();
    startAutoSlide();
  };

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const delta = touchStartX.current - touchEndX.current;

    if (Math.abs(delta) > 50) {
      if (!isCooldown) {
        delta > 0 ? nextImage() : prevImage();
        triggerCooldown();
        startAutoSlide();
      }
    }
  };

  useEffect(() => {
    const anim = setInterval(() => {
      setAnimationType((prev) =>
        prev === "fade" ? "slide" : prev === "slide" ? "zoom" : "fade"
      );
    }, 24000);

    return () => clearInterval(anim);
  }, []);

  return (
    <div className="home">
      <section
        className={`hero ${animationType}-animation`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >

        {backgroundImages.map((img, index) => (
          <div
            key={index}
            className={`hero-background ${index === currentImageIndex ? "active" : "inactive"}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${img})`
            }}
          />
        ))}

        <button
          className="hero-nav prev"
          onClick={handlePrevClick}
          disabled={isCooldown}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <button
          className="hero-nav next"
          onClick={handleNextClick}
          disabled={isCooldown}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

        <div className="hero-dots">
          {backgroundImages.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${index === currentImageIndex ? "active" : ""}`}
              onClick={() => goToImage(index)}
              disabled={isCooldown}
            />
          ))}
        </div>

        <div className="hero-content">
          <h1>{t('discover')}</h1>
          <p>{t('heroText')}</p>
          <Link to="/tours" className="cta-button">{t('exploreTours')}</Link>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="features-title">{t("whyChooseUs")}</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🌟</div>
              <h3>{t("expertGuides")}</h3>
              <p>{t("expertDesc")}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>{t("bestPrices")}</h3>
              <p>{t("pricesDesc")}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>{t("safeSecure")}</h3>
              <p>{t("safeDesc")}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;